import {ACTION_TYPE_SET_PAGE} from '../actions/index'

export const forgetUserName = (state = {page:"main"}, action) => {
    switch (action.type) {
        case ACTION_TYPE_SET_PAGE:
            return {...state, page: action.page};
        default:
            return state;
    }

};